import { useEffect, useState } from "react"
import Biodata from "./partial/Biodata"
import NilaiRapor from "./partial/NilaiRapor"
import Prestasi from "./partial/Prestasi"
import { useLocation, useNavigate, useSearchParams } from "react-router-dom"
import Ijazah from "./partial/Ijazah"
import api from "@/lib/axios"
import { useQuery } from "@tanstack/react-query"
import { AxiosError } from "axios"
import { FaFaceSadTear } from "react-icons/fa6"

const getDataBiodata = async (searchQuerySiswa: string) => {
  const response = await api.get(
    `/verifikator/daftar-kembali/loket-4/data-biodata?id=${searchQuerySiswa}`
  )
  return response.data
}

const getDataIjazah = async (searchQuerySiswa: string) => {
  const response = await api.get(
    `/verifikator/daftar-kembali/loket-4/data-ijazah?id=${searchQuerySiswa}`
  )
  return response.data
}

const getDataNilaiRapor = async (searchQuerySiswa: string) => {
  const response = await api.get(
    `/verifikator/daftar-kembali/loket-4/data-nilai-rapor?id=${searchQuerySiswa}`
  )
  return response.data
}

const getDataPrestasi = async (searchQuerySiswa: string) => {
  const response = await api.get(
    `/verifikator/daftar-kembali/loket-4/data-prestasi?id=${searchQuerySiswa}`
  )
  return response.data
}

export default function Loket4({ disabled }: { disabled: boolean }) {
  const location = useLocation()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const idParams = searchParams.get("id")
  const menuParams = searchParams.get("menu")
  const [activeMenu, setActiveMenu] = useState(
    menuParams ? Number(menuParams) : 1
  )

  const {
    data: dataBiodata,
    isPending: isPendingDataBiodata,
    error: errorDataBiodata,
  } = useQuery({
    queryKey: ["dataBiodata", idParams],
    queryFn: () => getDataBiodata(idParams || ""),
    enabled: !!idParams,
  })

  const {
    data: dataIjazah,
    isPending: isPendingDataIjazah,
    error: errorDataIjazah,
  } = useQuery({
    queryKey: ["dataIjazah", idParams],
    queryFn: () => getDataIjazah(idParams || ""),
    enabled: !!idParams,
  })

  const {
    data: dataNilaiRapor,
    isPending: isPendingDataNilaiRapor,
    error: errorDataNilaiRapor,
  } = useQuery({
    queryKey: ["dataNilaiRapor", idParams],
    queryFn: () => getDataNilaiRapor(idParams || ""),
    enabled: !!idParams,
  })

  const {
    data: dataPrestasi,
    isPending: isPendingDataPrestasi,
    error: errorDataPrestasi,
  } = useQuery({
    queryKey: ["dataPrestasi", idParams],
    queryFn: () => getDataPrestasi(idParams || ""),
    enabled: !!idParams,
  })

  useEffect(() => {
    if (!menuParams) return
    setActiveMenu(Number(menuParams))
  }, [menuParams])

  if (disabled) {
    return (
      <div className="flex justify-center items-center h-[50vh]">
        <div>
          <FaFaceSadTear className="mx-auto" size={40} />
          <h1 className="mt-3 text-xl font-semibold text-center">
            Siswa atas nama {dataBiodata?.data?.siswa?.nama_lengkap}{" "}
            <span className="text-primary">
              belum divalidasi di loket sebelumnya
            </span>
          </h1>
        </div>
      </div>
    )
  }

  return (
    <div>
      <div className="flex justify-between gap-3">
        <div className="w-fit h-fit rounded-full border font-semibold overflow-hidden">
          <button
            className={`py-2 px-4 ${
              activeMenu === 1
                ? "bg-black/90 text-white rounded-full"
                : "hover:bg-secondary"
            }`}
            onClick={() => {
              setActiveMenu(1)
              searchParams.set("menu", "1")
              navigate(`${location.pathname}?${searchParams.toString()}`)
            }}
          >
            Biodata
          </button>
          <button
            className={`py-2 px-4 ${
              activeMenu === 2
                ? "bg-black/90 text-white rounded-full"
                : "hover:bg-secondary"
            }`}
            onClick={() => {
              setActiveMenu(2)
              searchParams.set("menu", "2")
              navigate(`${location.pathname}?${searchParams.toString()}`)
            }}
          >
            Ijazah
          </button>
          <button
            className={`py-2 px-4 ${
              activeMenu === 3
                ? "bg-black/90 text-white rounded-full"
                : "hover:bg-secondary"
            }`}
            onClick={() => {
              setActiveMenu(3)
              searchParams.set("menu", "3")
              navigate(`${location.pathname}?${searchParams.toString()}`)
            }}
          >
            Nilai Raport
          </button>
          <button
            className={`py-2 px-4 ${
              activeMenu === 4
                ? "bg-black/90 text-white rounded-full"
                : "hover:bg-secondary"
            }`}
            onClick={() => {
              setActiveMenu(4)
              searchParams.set("menu", "4")
              navigate(`${location.pathname}?${searchParams.toString()}`)
            }}
          >
            Prestasi
          </button>
        </div>
        <div className="text-end">
          <h1 className="font-semibold">
            {dataBiodata?.data?.siswa?.nama_lengkap}
          </h1>
          <p className="text-muted-foreground">
            {dataBiodata?.data?.nomor_pendaftaran}
          </p>
        </div>
      </div>

      <div className="mt-10">
        {activeMenu === 1 && (
          <Biodata
            data={dataBiodata?.data}
            isPending={isPendingDataBiodata}
            error={errorDataBiodata as AxiosError}
          />
        )}
        {activeMenu === 2 && (
          <Ijazah
            data={dataIjazah?.data}
            isPending={isPendingDataIjazah}
            error={errorDataIjazah as AxiosError}
          />
        )}
        {activeMenu === 3 && (
          <NilaiRapor
            data={dataNilaiRapor?.data}
            isPending={isPendingDataNilaiRapor}
            error={errorDataNilaiRapor as AxiosError}
          />
        )}
        {activeMenu === 4 && (
          <Prestasi
            data={dataPrestasi?.data}
            isPending={isPendingDataPrestasi}
            error={errorDataPrestasi as AxiosError}
          />
        )}
      </div>
    </div>
  )
}
